module.exports = __webpack_public_path__ + "img/Logo_Dolby_Atmos.fe2c14b8.svg";